/**
 * 交易汇总
 */
import React from 'react';
import { Row, Col, DatePicker, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth'

class StatisticsDayIndex extends React.Component {

    columns = [{
        title: '日期',
        dataIndex: 'tradeDate',
        width: '10%',
    }, {
        title: '交易数',
        dataIndex: 'invoiceNum',
        width: '10%',
    }, {
        title: '收款金额',
        dataIndex: 'invoiceAmount',
        width: '10%',
    }, {
        title: '作废数',
        dataIndex: 'scrapInvoiceNum',
        width: '10%',
    }, {
        title: '税票数',
        dataIndex: 'taxNum',
        width: '10%',
    }, {
        title: '税票金额',
        dataIndex: 'taxAmount',
        width: '10%',
    }, {
        title: '未开税票数',
        dataIndex: 'unbilledTaxNum',
        width: '10%',
    }, {
        title: '未开税票金额',
        dataIndex: 'unbilledTaxAmount',
        width: '10%',
    }, {
        title: '充值商户数',
        dataIndex: 'memberNum',
        width: '10%',
        // }, {
        //     title: '充值金额',
        //     dataIndex: 'rechargeAmount',
        //     width: '10%',
    }, {
        title: '充值金额',
        dataIndex: 'actualRechargeAmount',
        width: '10%',
    }, {
        title: '赠送金额',
        dataIndex: 'giftRechargeAmount',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {
        },

        loadingVisible: false,

    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //导出
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "" || queryData.endDate == null || queryData.endDate === "") {
            messager.notify("导出时需选择时间段！", null, "warning");
            return;
        }
        this.setState({ loadingVisible: true });
        let fileName = queryData.startDate + "~" + queryData.endDate + " trade statistics.xlsx";
        http.download({
            url: '/tradeStatistics/downloadStatisticsDay',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
        messager.notify("只会根据查询的时间段导出已经打印的数据！");
    }

    //生成今日的统计汇总
    create = () => {
        messager.confirm("是否生成今日的统计汇总，如果已经生成了将会覆盖已生成的数据？", () => {
            http.post({
                url: '/tradeStatistics/createDayStatistics',
                success: (res) => {
                    messager.notify("生成汇总数据成功！");
                    this.state.loadData(this.state.queryData);
                }
            });
        });
    }

    downloadUnprintTax = () => {
        this.setState({ loadingVisible: true });
        http.download({
            url: '/tradeStatistics/downloadUnprintTax',
            data: {},
            fileName: "今日未开税票车辆信息.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) =>{
                messager.notify("导出失败，请联系管理员！");
                this.setState({ loadingVisible: false });
            }
        });
    }


    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                {/* <Input.Search
                                    placeholder="车牌号/车架号/新车主"
                                    onSearch={value => this.state.loadData({ queryString: value })}
                                    enterButton
                                /> */}
                                <DatePicker.RangePicker
                                    onChange={this.rangePickerChange} />

                                <OrgSelect style={{ width: '200px', marginLeft: '10px' }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                                <Button type="primary" onClick={this.downloadUnprintTax} style={{ "float": "right" }}>未开税票</Button>
                                <Button type="primary" onClick={this.download} style={{ "float": "right", margin: '0 10px' }}>导出</Button>
                                {global_data.authCode.includes("TRADE_STATISTICS_ADD")?
                                <Button type="primary" onClick={this.create} style={{ "float": "right" }}>创建</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/tradeStatistics/findDayStatisticsPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />

            </div>
        )
    }
}

export default StatisticsDayIndex;